import { render, staticRenderFns } from "./ComprehensiveEvaluation.vue?vue&type=template&id=c2031bae&scoped=true"
import script from "./ComprehensiveEvaluation.vue?vue&type=script&lang=js"
export * from "./ComprehensiveEvaluation.vue?vue&type=script&lang=js"
import style0 from "./ComprehensiveEvaluation.vue?vue&type=style&index=0&id=c2031bae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2031bae",
  null
  
)

export default component.exports